<app-leveltwo [pageName]="'Wills and Trusts'">
<div class="General">
  <h3>{{'WillsandTrust.SearchTitle'|translate}}</h3>

      <h4>{{'WillsandTrust.Revocable'|translate}}</h4>
      <p>{{'WillsandTrust.Arevocable'|translate}}</p>
      <p>{{'WillsandTrust.Uponthedeath'|translate}}</p>
      <h4>{{'WillsandTrust.Irrevocable'|translate}}</h4>
      <p>{{'WillsandTrust.Anirrevocable'|translate}}</p>
      <h4>{{'WillsandTrust.TrustDist'|translate}} </h4>
      <p>{{'WillsandTrust.Whenproperty'|translate}}</p>

</div>
</app-leveltwo>
